import React from 'react';

import Box from '@mui/material/Box';

import BankFeedGrid from 'pages/company/BankFeedRoute/components/BankFeedGrid';
import EmptyState from 'pages/company/BankFeedRoute/components/EmptyStates/EmptyState';
import { computeEmptyVariant } from 'pages/company/BankFeedRoute/components/EmptyStates/computeEmptyVariant';
import { useBankFeedRouteContext } from 'pages/company/BankFeedRoute/context';

const CreditCardTransactionsRoute: React.FC = () => {
  const { accountType, summary } = useBankFeedRouteContext();

  const emptyVariant = computeEmptyVariant(summary, accountType);

  return (
    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
      {emptyVariant ? <EmptyState variant={emptyVariant} /> : <BankFeedGrid />}
    </Box>
  );
};

export default CreditCardTransactionsRoute;
